import { render, staticRenderFns } from "./ClientsCrudPage.vue?vue&type=template&id=7de93882&"
import script from "./ClientsCrudPage.vue?vue&type=script&lang=js&"
export * from "./ClientsCrudPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports